
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/redirect",
      function () {
        return require("private-next-pages/redirect/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/redirect"])
      });
    }
  